export const DISNEY_FOLDER_NAMES = {
  'available-now': 'Ya disponible',
  'seasonality-300x600': 'Seasonality',
  ctv: 'CTV',

  // Rugby - URBA Top 12
  'espn/espn-vs/rugby/urba-top-12/vertical': 'Vertical',
  'espn/espn-vs/rugby/urba-top-12/miniatura': 'Miniatura',

  // Fútbol - La Liga, Premier League, Conmebol Libertadores
  'espn/espn-vs/futbol/la-liga/vertical': 'Vertical',
  'espn/espn-vs/futbol/la-liga/miniatura': 'Miniatura',
  'espn/espn-vs/futbol/premier-league/miniatura': 'Miniatura',
  'espn/espn-vs/futbol/conmebol-libertadores/vertical': 'Vertical',

  // ESPN Heros
  'espn/espn-heros': 'ESPN Heros',
  'espn/espn-heros/premier-league': 'Premier League'
} as const;
